export default {
    Auth: {
        region: `${process.env.REACT_APP_COGNITO_REGION as string}`,
        userPoolId: `${process.env.REACT_APP_COGNITO_POOL_ID as string}`,
        userPoolWebClientId: `${process.env.REACT_APP_COGNITO_CLIENT_ID as string}`,
        mandatorySignIn: false,
    },
};
